import * as m from '~/paraglide/messages'
import type { PriceLevelValue } from '~/shared/types'
import { SegmentedControl } from '~/shared/ui/segmented-control'

const LEVELS = ['1', '2', '3', '4'] as const

interface PriceLevelControlProps {
  value: PriceLevelValue
  onChange: (value: PriceLevelValue) => void
}

export function PriceLevelControl({ value, onChange }: PriceLevelControlProps) {
  return (
    <SegmentedControl<PriceLevelValue>
      label={m.listingPriceLevel()}
      value={value}
      onChange={onChange}
      options={[
        { value: '', label: m.listingPriceLevelNone() },
        ...LEVELS.map((level) => ({ value: level, label: '€'.repeat(Number(level)) })),
      ]}
    />
  )
}
